"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialContractSharedUpdateFields = exports.CommercialContractSharedCreateFields = exports.CommercialContractSharedQuery = exports.CommercialContractSharedFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
exports.CommercialContractSharedFields = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.String({ format: 'date' }), // Calculated from startDate + termLength on the backend.
    termUnit: enums_1.CommercialTermUnit,
    termLength: typebox_1.Type.Integer({ minimum: 0 }),
    subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    metadata: common_1.MetaData,
});
exports.CommercialContractSharedQuery = typebox_1.Type.Object({
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    startsBefore: typebox_1.Type.String({ format: 'date' }),
    startsAfter: typebox_1.Type.String({ format: 'date' }),
    endsBefore: typebox_1.Type.String({ format: 'date' }),
    endsAfter: typebox_1.Type.String({ format: 'date' }),
    subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.CommercialContractSharedCreateFields = typebox_1.Type.Omit(exports.CommercialContractSharedFields, [
    'id',
    'haulerID',
    'customerID',
    'endDate',
    'subscriptionID',
    'metadata',
]);
exports.CommercialContractSharedUpdateFields = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.CommercialContractSharedFields, ['id', 'haulerID', 'customerID', 'endDate', 'subscriptionID', 'metadata']));
//# sourceMappingURL=commercial-contract-shared.js.map